import { typedAction } from "../helpers";
import { SET_EXPANDED_ITEM } from "./actionTypes";
import { IExpander } from "../models/IExpander";
import { expanderConstants } from "../models/constants/expanders";

const initialState = { //true here means collapsed. 
    [expanderConstants.home.pinned]: true,
    [expanderConstants.home.recent]: true,
    [expanderConstants.home.locations]: false,
    [expanderConstants.home.shared]: true,
    [expanderConstants.home.approvalCenter]: true,
    [expanderConstants.teams.joinedTeams]: false,
    [expanderConstants.teams.channels]: false,
    [expanderConstants.sharepoint.sites]: false,
    [expanderConstants.sharepoint.folders]: false,
    [expanderConstants.sharepoint.files]: false,
    [expanderConstants.sharepointDocument.libraries]: false,
    [expanderConstants.sharepointDocument.subsites]: false,
    [expanderConstants.sharepointDocument.clientGroup]: false,
    [expanderConstants.tess.activeProjects]: false,
    [expanderConstants.tess.draftProjects]: false,
    [expanderConstants.tess.finishedProjects]: false,
};

export const setExpandedItem = (expanderItem: IExpander) => {
    return typedAction(SET_EXPANDED_ITEM, expanderItem);
};

type ExpandersAction = ReturnType<typeof setExpandedItem>;

export function expandersReducer(
    state = initialState,
    action: ExpandersAction
) {
    switch (action.type) {
        case SET_EXPANDED_ITEM:
            return { ...state, [action.payload.property]: action.payload.toggle };
        default:
            return state;
    }
}

